import type { MutationConfig } from "apps/visits/core/lib/react-query";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type UseResendVerificationCodeOptions = {
  config?: MutationConfig<typeof vouchersDistributionsRepository.resendVerificationCode>;
};

export const useResendVerificationCode = ({ config }: UseResendVerificationCodeOptions) => {
  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.resendVerificationCode(data),
  });
};
